<template>
  <div class="lesson_item">
    <form @submit.prevent="saveStage()">
      <div class="parts">
        <div class="part-left">
          <div class="row">
            <div class="lesson_type">
              <span class="left">Тип урока: </span>
              <span class="right">{{ lessonType(element) }}</span>
            </div>
            <div class="lesson_author" v-if="userRole === 'admin'">
              <span class="left">Автор: </span>
              <router-link :to="'/all-users/' + element.user_id">
                <span class="right blue">{{ currentAuthor }}</span>
              </router-link>
            </div>
            <div class="lesson_date">
              <span class="left">Дата создания: </span>
              <span class="right">{{ element.created_at | moment('DD.MM.YYYY') }}</span>
            </div>
          </div>
          <div class="row" v-if="element.type === 3">
            <div class="lesson_time">
              <span class="left">Длительность: </span>
              <span class="right">{{ element.test_material.duration + ' мин' }}</span>
            </div>
          </div>
          <div class="row">
            <div class="lesson_name">
              <span class="left">Название урока: </span>
              <span class="right">{{ element.name }}</span>
            </div>
          </div>
          <div class="row inputs" v-if="element.type === 2 || element.type === 3">
            <b-field v-if="element.type === 2" label="Попытки:" class="timepicker_field">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="element.test_material.attempt_count"
                type="number"
                min="1"
                placeholder="1"
                required
              />
            </b-field>
            <b-field label="Порог прохождения (%):" class="timepicker_field">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="element.test_material.percent"
                type="number"
                placeholder="1"
                required
              />
            </b-field>
            <b-field v-if="element.type === 3" label="Кол-во вопросов из тем:" class="timepicker_field">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="element.test_material.questions_per_theme"
                type="number"
                placeholder="1"
              />
            </b-field>
            <b-field v-if="element.type === 3" label="Длительность (мин):" class="timepicker_field">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="element.test_material.duration"
                type="number"
                placeholder="1"
              />
            </b-field>
          </div>
        </div>
        <div class="part-right">
          <div class="row">
            <button class="edit_button" type="submit"><i class="mdi mdi-content-save-outline"></i> Сохранить</button>
            <div class="delete_button" @click="$emit('delete', element.id)">
              <i class="mdi mdi-file-document-box-remove-outline"></i> Удалить
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    element: {
      default: () => {},
      type: Object
    },
    item: {
      default: () => {},
      type: Object
    },
    fieldsChanged: {
      default: () => {},
      type: Object
    },
    currentAuthor: {
      default: () => '',
      type: String
    }
  },
  data() {
    return {
      dict: {
        custom: {
          attempt_count: {
            required: 'Поле не заполнено'
          },
          percent: {
            required: 'Поле не заполнено'
          }
        }
      }
    }
  },
  methods: {
    lessonType(e) {
      switch (e.type) {
        case 1:
          return 'Урок'
        case 2:
          return 'Обучающий тест'
        case 3:
          return 'Итоговый тест'
      }
    },
    saveStage() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit(this.item.action, this.element.id)
        }
      })
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
